export default {
  title: {
    id: 'profile_page_company_info_tab_title',
    defaultMessage: 'Business details',
  },
  editButton: {
    id: 'profile_page_company_info_tab_edit_button',
    defaultMessage: 'Edit',
  },
  modalTitle: {
    id: 'profile_page_company_info_tab_modal_title',
    defaultMessage: 'Add business details',
  },
  companyLabel: {
    id: 'profile_page_company_info_tab_modal_form_company_label',
    defaultMessage: 'Company',
  },
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
  modalInfoBlockTitle: {
    id: 'profile_page_company_info_tab_modal_info_block_title',
    defaultMessage: 'Heads up',
  },
  modalInfoBlockContent: {
    id: 'profile_page_company_info_tab_modal_info_block_content',
    defaultMessage: 'This information will be visible to your customers.',
  },
  submitButton: {
    id: 'profile_page_company_info_edit_modal_submit_button',
    defaultMessage: 'Add details',
  },
  cancelButton: {
    id: 'profile_page_company_info_edit_modal_cancel_button',
    defaultMessage: 'Cancel',
  },
  addressUpdatedToastSuccessTitle: {
    id: 'profile_page_company_info_edit_modal_success_toast_title',
    defaultMessage: 'Details updated ✔️',
  },
  addressUpdatedToastSuccessContent: {
    id: 'profile_page_company_info_edit_modal_success_toast_content',
    defaultMessage: 'You’re that much closer to selling on Back Market.',
  },
  companyRequired: {
    id: 'profile_page_company_info_edit_modal_fields_required',
    defaultMessage: 'This field is required',
  },
  errorTitle: {
    id: 'profile_page_company_info_edit_modal_error_title',
    defaultMessage: 'Oops...',
  },
}
